module.exports = __webpack_public_path__ + "static/media/experian-mbp.8fe9a595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/digitalNomad/web-development/experian-mbp.png
// module id = 168
// module chunks = 0